export default "__VITE_ASSET__n02LgsSk__"